import { ButtonSound } from '@jollywise/jollygoodgame/src/input/ButtonSound';

export class ButtonSoundTT extends ButtonSound {
  constructor(...args) {
    super(...args);
    this._hitarea = {
      x: -this.width * 0.5,
      y: -this.height * 0.5,
      width: this.width,
      height: this.height,
    };
  }

  enable() {
    super.enable();
  }

  handleAudioChanged() {
    this.disable();
    this.enterButtonRestState();
    super.handleAudioChanged();
    this.enable();
  }

  updateDisplayStatus({ isMuted }) {
    this.state = isMuted ? OFF : ON;
    this.gelvo = this.state === OFF ? 'turn_sound_on' : 'turn_sound_off';
    this.costume = this.id + this.state;
    this.setTexture('buttons', this.costume);
  }

  setTexture(...args) {
    super.setTexture(...args);
    if (this.input && this._hitarea) {
      this.input.hitArea.setTo(
        this.width * 0.5 + this._hitarea.x,
        this.height * 0.5 + this._hitarea.y,
        this._hitarea.width,
        this._hitarea.height
      );
    }
  }
}

const ON = '_on';
const OFF = '_off';
